export default __webpack_public_path__ + "static/media/detail1.94af2d6d.jpeg";